import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {TTypeConstructor} from '@packages/systems/wfdl-ast';
import {Plugins} from '@packages/systems/wfdl';

export const VisibilityConditionsType = TTypeConstructor(
  qualify(Plugins.name('Visibility'), typeName('VisibilityConditions'))
);
